import Image, { ImageProps } from "next/image";

const SIGNED_S3_HOST = "https://s3.ap-northeast-1.amazonaws.com";

function isSignedS3Url(src: ImageProps["src"]): boolean {
  if (typeof src !== "string") {
    return false;
  }

  if (!src.startsWith(SIGNED_S3_HOST)) {
    return false;
  }

  return src.includes("X-Amz-") || src.includes("X-Amz-Expires");
}

const SafeImage = ({ unoptimized, src, alt, ...rest }: ImageProps) => {
  const shouldBypassOptimization = isSignedS3Url(src);

  return (
    <Image
      {...rest}
      src={src}
      alt={alt}
      unoptimized={unoptimized ?? shouldBypassOptimization}
    />
  );
};

export default SafeImage;
